import { FieldType } from 'enums/FieldTypeEnums';
import { FieldsRowProps } from 'shared/components/FieldsRow';
import React from 'react';
import { Col, Row } from 'antd';

export const sampleFieldsRowData: FieldsRowProps = {
  data: [
    {
      type: FieldType.INPUT,
      fieldProps: {
        name: 'inputFieldA',
        placeholderstring: 'Input Placeholder',
        label: 'Input Label',
      },
      span: 4,
    },
    {
      type: FieldType.CHECKBOX,
      fieldProps: {
        name: 'checkBoxA',
        label: (
          <Row>
            <Col>CheckBox Label</Col>
          </Row>
        ),
      },
      span: 4,
    },
    {
      type: FieldType.SELECT,
      fieldProps: {
        name: 'selectA',
        placeholderstring: 'Select Placeholder',
        label: 'Select Label',
        options: [
          { label: 'Option A', value: 'Option A' },
          { label: 'Option B', value: 'Option B' },
        ],
      },
      span: 4,
    },
    {
      type: FieldType.SWITCH,
      fieldProps: {
        name: 'switchA',
        label: 'Switch Title',
      },
      span: 4,
    },
    {
      type: FieldType.ELEMENT,
      additionalElement: (
        <Row>
          <Col>Additional Element</Col>
        </Row>
      ),
      span: 6,
    },
  ],
};
